export default {
  general: {
    alerts: {
      validationError: 'Data validation failed',
      saveError: 'Error saving settings - {{error}}',
      rpcError: 'Error sending command - {{error}}'
    },
    buttons: {
      add: 'Add',
      cancel: 'Cancel',
      clear: 'Clear',
      close: 'Close',
      delete: 'Delete',
      edit: 'Edit',
      ok: 'OK',
      no: 'No',
      reload: 'Reload',
      remove: 'Remove',
      save: 'Save',
      yes: 'Yes'
    },
    storeErrors: {
      create_exists: 'Subfolder already exists',
      create_illegalname: 'Subfolder name is not allowed',
      create_invalidchars: 'Subfolder name contains invalid characters',
      create_invalidpath: 'Subfolder path is not allowed',
      create_norights: 'No permission to create subfolder',
      delete_subfoldersexist: 'Subfolders exist'
    },
    text: {
      loading: 'Loading',
      no: 'No',
      rootFolder: 'Root folder',
      selectUser: 'Select user',
      yes: 'Yes'
    },
    validation: {
      minValue: 'This field must be at least {{value}}',
      required: 'This field is required',
      minLength: 'This field must be at least {{value}} characters long',
      maxLength: 'This field must be no more than {{value}} characters long',
      fixedLength: 'This field must be {{value}} characters long',
      server: 'The server rejected this value',
      serverExtraInfo: 'The server rejected this value - {{error}}',
      thisField: 'this field'
    }
  },
  translation: {
    addressBook: {
      owned: '{{owner}}/{{name}}',
      personal: 'Personal/{{name}}',
      standard: {
        all: 'All addressbook entries',
        collected: 'Collected entries',
        internal: 'Internal entries',
        lists: 'Internal lists',
        users: 'Internal users',
        external: 'External entries',
        global: 'Global addressbook',
        personal: 'Personal entries'
      }
    },
    addresses: {
      book: 'Book: ',
      newBook: {
        button: 'Create personal book',
        title: 'Create new personal address book',
        instructions: 'Enter the name for the new personal address book',
        label: 'Address book name',
        placeholder: '$t(addresses.newBook.label)',
        errors: {
          nameExists: 'Name already exists',
          nameTooLong: 'Name too long',
          nameRequired: 'A name is required'
        },
        saveError: 'An error occurred creating the address book - {{error}}'
      },
      newEntry: {
        button: 'Create new entry',
        buttons: {
          ok: '$t(general:buttons.ok)',
          cancel: '$t(general:buttons.cancel)'
        },
        errors: {
          emailRequired: 'Email address is required',
          emailFormat: 'A valid email address is required'
        },
        title: 'Create new address book entry',
        titleName: '{{cn}}',
        instructions: 'Enter the name and email address of the new entry. Extra information can be added later',
        gnLabel: '$t(addrEntry.gn)',
        gnPlaceholder: '$t(addresses.newEntry.gnLabel)',
        initialsLabel: '$t(addrEntry.initials)',
        initialsPlaceholder: '$t(addresses.newEntry.initialsLabel)',
        snLabel: '$t(addrEntry.sn)',
        snPlaceholder: '$t(addresses.newEntry.snLabel)',
        mailLabel: '$t(addrEntry.mail)',
        mailPlaceholder: '$t(addresses.newEntry.mailLabel)'
      },
      deleteBook: 'Delete this book',
      shareBook: 'Share this book',
      confirmDelete: 'Are you sure you want to delete the address book: {{-name}}',
      deleteAddrBookError: 'An error occurred deleting the address book - {{error}}'
    },
    addrEntry: {
      book: 'Address book',
      cn: 'Display name',
      gn: 'First name',
      initials: 'Middle initials',
      sn: 'Last name',
      mail: 'Email address',
      telephone: 'Phone numbers',
      telephonenumber: 'Business',
      homephone: 'Home',
      mobile: 'Mobile',
      fax: 'Fax',
      businessinfo: 'Business information',
      title: 'Job title',
      physicaldeliveryofficename: 'Office',
      ou: 'Department',
      o: 'Company',
      postaladdress: 'Address',
      l: 'City',
      st: 'State/region',
      postalcode: 'Postcode',
      c: 'Country',
      personalinfo: 'Personal information',
      homepostaladdress: 'Address',
      info: 'Information',
      url: 'URL',
      nav: {
        sendTo: 'To',
        copyEmail: 'Copy email',
        edit: '$t(general:buttons.edit)',
        delete: '$t(general:buttons.delete)',
        save: '$t(general:buttons.save)',
        cancel: '$t(general:buttons.cancel)'
      },
      placeholder: {
        telephonenumber: 'Business telephone',
        homephone: 'Home telephone',
        mobile: 'Mobile telephone',
        fax: 'Fax',
        title: 'Job title',
        physicaldeliveryofficename: 'Office name',
        ou: 'Department',
        o: 'Company',
        postaladdress: 'Business address',
        l: 'Business city',
        postalcode: 'Business postal code',
        c: 'Business country',
        homepostaladdress: 'Home address',
        info: '$t(addrEntry.info)',
        url: '$t(addrEntry.url)'
      },
      saveError: 'An error occurred saving the address book entry - {{error}}',
      deleteError: 'An error occurred deleting the address book entry - {{error}}'
    },
    app: {
      loadingApp: 'Loading application',
      errorLoadingApp: 'Error loading application'
    },
    appbar: {
      account: 'Account',
      addresses: 'Addresses',
      calendar: 'Calendar',
      folders: 'Folders',
      logout: 'Logout',
      messages: 'Messages',
      newMessage: 'Compose',
      rules: 'Inbox rules',
      runRules: 'Run manual rules',
      settings: 'Settings',
      tools: 'Tools'
    },
    calendars: {
      list: {
        error: 'Error loading calendar list: {{error}}',
        calendar: '{{name}}',
        sharedCalendar: '{{owner}}: {{name}}'
      },
      nav: {
        day: 'Day',
        week: 'Week',
        month: 'Month',
        next: 'Next',
        previous: 'Previous',
        today: 'Today',
        new: 'New event'
      },
      newEventSummary: 'New event',
      weekTitle: '{{from, DATE_HUGE}} - {{to, DATE_HUGE}}',
      eventSaveFailed: 'Failed to save calendar event - {{error}}',
      event: {
        allday: 'All-day event',
        count: 'Recurrence count',
        description: 'Description',
        descriptionPlaceholder: 'Event description',
        recurring: 'This event recurs regularly',
        summaryPlaceholder: 'Event title',
        time: 'Time',
        timeSeparator: 'to',
        title: 'Edit: {{summary}}',
        until: 'Recur until',
        buttons: {
          ok: '$t(general:buttons.ok)',
          cancel: '$t(general:buttons.cancel)',
          delete: '$t(general:buttons.delete)'
        },
        editRecur: {
          title: 'Recurring event',
          details: 'You are about to edit a recurring event. Would you like to edit the whole ' +
            'series, or just this occurrence?',
          cancel: 'Cancel edit',
          allSeries: 'Whole series',
          justOne: 'Just this occurrence',
          future: 'This occurrence and later'
        },
        recur: {
          daily: 'Daily',
          weekly: 'Weekly',
          weekdays: 'Weekdays',
          biweekly: 'Biweekly',
          monthly: 'Monthly',
          yearly: 'Yearly',
          custom: 'Custom',
          forever: 'Forever',
          count: 'Count',
          until: 'Until'
        }
      }
    },
    dateTimePicker: {
      cancel: '$t(general:buttons.cancel)',
      clear: '$t(general:buttons.clear)',
      noDate: 'No date',
      noTime: 'No time',
      ok: '$t(general:buttons.ok)'
    },
    folderConfig: {
      title: 'Folder config: ',
      delete: 'Delete this folder',
      rename: 'Rename/move this folder',
      favouriteFolder: 'Favourite folder',
      childrenTitle: 'Subfolders',
      childName: '{{-name}}',
      childMessages: '{{count}} message\xa0',
      childMessages_plural: '{{count}} messages',
      childSize: '{{size, size}}',
      noChildren: 'No Subfolders defined',
      addChild: 'Add subfolder',
      addChildTitle: '$t(folderConfig.addChild)',
      addChildText: 'Enter the name of the subfolder to add',
      addChildPrompt: 'Child folder name',
      addChildError: 'Error adding subfolder - {{error}}',
      stats: 'Folder statistics',
      messageCount: 'Folder contains {{count}} message ({{unread}} unread) - total size {{size, size}}',
      messageCount_plural: 'Folder contains {{count}} messages ({{unread}} unread) - total size {{size, size}}',
      deleteConfirm: 'Are you sure you want to delete the "{{-folder}}" folder and subfolders?',
      deleteVerification: 'delete',
      deleteVerificationPrompt: 'Type "$t(folderConfig.deleteVerification)" to confirm deletion',
      deleteError: 'Error moving folder into Trash - {{error}}',
      permanentDeleteConfirm: 'Are you sure you want to PERMANENTLY delete the "{{-folder}}" folder and subfolders?',
      permanentDeleteError: 'Error deleting folder - {{error}}',
      permanentDeleteVerification: 'permanentdelete',
      permanentDeleteVerificationPrompt: 'Type "$t(folderConfig.permanentDeleteVerification)" to confirm deletion',
      permanentDeletingFolder: 'Deleting folder: {{-folder}}',
      cancelDelete: 'Cancel deleting folder',
      cancelledPermanentDelete: 'Cancelled deleting folder and subfolders',
      finishedDelete: 'Finished deleting folder',
      closeDelete: '$t(general:buttons.close)',
      renameDialogTitle: 'Rename/move folder',
      renameNameLabel: 'New folder name',
      renameParentLabel: 'Move to new parent',
      newPath: 'New Folder Path: {{-path}}',
      validErrors: {
        renameNameTooLong: 'New name too long (max {{maxchars}} characters)<br/>',
        renameNameInvalidChar: 'New name contains invalid characters (/)<br/>',
        renameNameRequired: 'New name is required'
      },
      acl: {
        title: 'Access control list',
        userSelectPlaceholder: 'Select user/group to add',
        builtin: {
          everyone: 'Users in EVERYONE group',
          admins: 'VPOP3 Administrators',
          anyone: 'All users'
        },
        type: {
          builtin: '(Built-in group)',
          group: '(User group)',
          user: '(User)'
        }
      },
      aclEditor: {
        title: 'Set access permissions for "{{user}}"',
        permissions: {
          l: 'See folder in folder list',
          r: 'Read messages',
          s: 'Mark messages seen/unseen',
          w: 'Set flags on messages',
          i: 'Copy into folder',
          k: 'Create subfolders',
          x: 'Delete folder',
          t: 'Delete messages',
          e: 'Purge messages',
          a: 'Administer folder'
        },
        save: '$t(general:buttons.save)',
        cancel: '$t(general:buttons.cancel)',
        delete: '$t(general:buttons.delete)'
      }
    },
    folderList: {
      unreadThousands: '{{unread}}k',
      folders: { // lets you localise standard folder names
        '*Outbox': 'Outbox',
        '*Quarantine': 'Quarantine'
      }
    },
    login: {
      loginFormTitle: 'VPOP3 Webmail login',
      checkingServer: 'Checking server availability',
      serverNotAvailableTitle: 'Server unavailable',
      serverNotAvailable: 'The mail server is currently not available. Please wait, or contact your ' +
        'system administrator',
      loginServerInfo: 'Logging in to: {{-server}}',
      serverInfo: '{{protocol}}//{{addr}}:{{port}}',
      serverInfoDefaultPort: '{{protocol}}//{{addr}}',
      username: 'User name',
      usernamePlaceholder: '$t(login.username)',
      password: 'Password',
      passwordPlaceholder: '$t(login.password)',
      tfaPassword: 'One-time password',
      tfaPasswordPlaceholder: '$t(login.tfaPassword)',
      language: 'Language',
      loginButton: 'Login',
      loginError: 'Login error - {{error}}',
      loginErrors: {
        badlogin: 'Invalid login username and/or password',
        bad2fa: 'Incorrect $t(login.tfaPassword)',
        badkey: 'Bad challenge key - please try again',
        missingkey: 'Missing challenge key - please contact support@pscs.co.uk',
        missing2fa: 'Missing $(login.tfaPassword) - please contact support@pscs.co.uk'
      }
    },
    logout: {
      confirm: 'Are you sure you want to log out?'
    },
    messageBar: {
      backToList: 'Back to message list',
      delete: 'Delete message',
      forward: 'Forward message',
      markUnread: 'Mark message unread',
      moveFolder: 'Move message to another folder',
      reply: 'Compose reply',
      replyAll: 'Compose reply to all participants',
      replyList: 'Compose reply to list',
      moreMenu: 'More options',
      menu: {
        showSource: 'Show message source',
        addAutomaticRule: 'Add automatic rule',
        addManualRule: 'Add manual rule',
        blockSender: 'Block sender'
      },
      menuSmall: {
        showSource: 'Show source',
        addAutomaticRule: 'Add auto rule',
        addManualRule: 'Add manual rule',
        blockSender: 'Block sender',
        markUnread: 'Mark unread',
        moveFolder: 'Move to folder'
      }
    },
    messageList: {
      htmlTitle: '{{user}} - {{name}}',
      pager: {
        currentPosition: '{{start}} to {{end}} of {{total}}',
        currentPositionSingle: '{{start}} of {{total}}',
        currentPositionFiltered: '{{start}} to {{end}} of {{filteredLength}} ({{total}})',
        currentPositionFilteredSingle: '{{start}} of {{filteredLength}} ({{total}})',
        next: 'Next page',
        noMessages: 'No messages',
        previous: 'Previous page'
      },
      pagerShort: {
        currentPosition: '{{start}}-{{end}}/{{total}}',
        currentPositionSingle: '{{start}}/{{total}}',
        currentPositionFiltered: '{{start}}-{{end}}/{{filteredLength}}',
        currentPositionFilteredSingle: '{{start}}/{{filteredLength}}',
        next: '$t(messageList.pager.next)',
        noMessages: 'No msgs',
        previous: '$t(messageList.pager.previous)'
      }
    },
    messageView: {
      htmlTitle: '{{user}} - {{folder}} - {{subject}}',
      from: '',
      subject: '',
      cc: 'cc',
      ccSeparator: ', ',
      fromUnknown: '<Unknown Sender>',
      loadError: 'Error loading message - {{error}}',
      toOnly: '',
      to: 'to',
      toSeparator: ', ',
      imagesBlocked: 'Images have been blocked to protect your privacy',
      imagesBlockedByAdministrator: 'Images have been blocked by your administrator to protect your privacy',
      showImagesOnce: 'Show images',
      showImagesFromSender: 'Always show images from {{sender}}',
      spamdataLabel: 'Spam reason ',
      attachmentName: '{{name}}',
      attachmentSize: '{{size, size}}'
    },
    messageListBar: {
      selected: '{{count}} msg selected',
      selected_plural: '{{count}} msgs selected',
      selectedShort: '{{count}}',
      delete: 'Delete selected messages',
      markRead: 'Mark selected messages read',
      markUnread: 'Mark selected messages unread',
      markReadMenu: 'Mark read',
      markUnreadMenu: 'Mark unread',
      markStarred: 'Mark selected messages with a star',
      markUnstarred: 'Remove star from selected messages',
      markStarredMenu: 'Star',
      markUnstarredMenu: 'Remove star',
      moveFolder: 'Move selected messages to another folder',
      selectAll: 'Select all messages',
      unselectAll: 'Unselect all messages',
      moreMenu: 'More options',
      refresh: 'Refresh message list',
      menu: {
        ariaName: 'Message list more actions menu',
        markAllRead: 'Mark all read',
        showSent: 'Show recent sent messages',
        deleteAll: 'Delete all',
        undeleteAll: 'Undelete all'
      }
    },
    moveSelector: {
      copyMode: 'Copy instead of Move [Alt+C]',
      ariaFolderList: 'List of folders to move or copy to',
      ariaSearchBox: 'Filter folders in list'
    },
    messageEditor: {
      aria: {
        addImage: 'Add image',
        addLink: 'Add link',
        align_left: 'Align left',
        align_center: 'Align centre',
        align_right: 'Align right',
        align_justify: 'Align justified',
        bold: 'Bold',
        codeFormat: 'Code format',
        emoji: 'Emoji picker',
        fontMenu: 'Font selector',
        headerMenu: 'Header selector',
        highlightColourPicker: 'Highlight colour picker',
        hr: 'Horizontal Rule',
        indent: 'Indent',
        italic: 'Italic',
        justifyOptions: 'Text justification menu',
        link: 'Add link',
        list: 'Bullet list',
        manageAttachments: 'Manage attachments',
        orderedList: 'Number list',
        outdent: 'Undo indent',
        quote: 'Quote',
        redo: 'Redo',
        removeFormatting: 'Remove all formatting',
        removeLink: 'Remove link',
        specialCharacter: 'Special character picker',
        strikethrough: 'Strikethrough',
        textColourPicker: 'Text colour picker',
        textSizeMenu: 'Text Size selector',
        underline: 'Underline',
        undo: 'Undo',
        viewSource: 'View HTML source'
      },
      addImage: {
        ariaName: 'Insert image options'
      },
      attachments: {
        ariaName: 'Message attachments'
      },
      justifyMenu: {
        aria: 'Alignment options'
      },
      headerMenu: {
        ariaName: 'Header options',
        h1: 'H1',
        h2: 'H2',
        h3: 'H3'
      },
      textSizeMenu: {
        ariaName: 'Text size options',
        small: 'Small',
        medium: 'Medium',
        large: 'Large',
        huge: 'Huge'
      },
      fontMenu: {
        ariaName: 'Font options',
        fonts_1: 'Arial, Helvetica',
        fontsText_1: 'Sans Serif (Arial, Helvetica)',
        fonts_2: '"Times New Roman", Times, serif',
        fontsText_2: 'Serif (Times New Roman)',
        fonts_3: '"Lucida Console", Monaco, monospace',
        fontsText_3: 'Monospace (Lucida, Monaco)',
        fonts_4: '',
        fonts_5: '"Courier New", Courier, monospace',
        fontsText_5: 'Courier ',
        fonts_6: 'Impact, Charcoal',
        fontsText_6: 'Impact, Charcoal',
        fonts_7: '"Lucida Sans Unicode", "Lucida Grande"',
        fontsText_7: 'Lucida Sans, Lucida Grande',
        fonts_8: '"Palatino Linotype", Palatino, serif',
        fontsText_8: 'Paltino Linotype',
        fonts_9: 'Tahoma, Geneva',
        fontsText_9: 'Tahoma, Geneva',
        fonts_10: '"Trebuchet MS", Helvetica',
        fontsText_10: 'Trebuchet MS, Helvetica'
      },
      addLink: {
        ariaName: 'Add link',
        placeholder: 'URL...'
      },
      attachmentInfo: '{{count}} attachment ({{size, sizekb}})',
      attachmentInfo_plural: '{{count}} attachments ({{size, sizekb}})',
      bcc: 'Bcc',
      cc: 'Cc',
      dropTooBig: 'The dropped files are too large ({{size, size}})',
      from: 'From',
      loadingAttachments: 'Loading {{count}} attachment',
      loadingAttachments_plural: 'Loading {{count}} attachments',
      messageSize: 'Message size: {{size, sizekb}}',
      noSubjectTitle: 'New Message',
      processing: 'Processing',
      sendButton: 'Send',
      sending: 'Sending {{progress}}%',
      subjectPlaceholder: 'Subject...',
      reCiteInfo: '<p></p><hr><b>From:</b> {{fromname}} &lt;{{fromaddr}}&gt;<br>' +
        '<b>Sent:</b> {{date, DATETIME_FULL}}<br>' +
        '<b>To:</b> {{recipients}}<br><b>Subject:</b> {{subject}} <br><br><blockquote>{{-message}}</blockquote>',
      rePrefix: 'Re:',
      reAllCiteInfo: '$t(messageEditor.reCiteInfo)',
      reAllPrefix: '$t(messageEditor.rePrefix)',
      reListCiteInfo: '$t(messageEditor.reCiteInfo)',
      reListPrefix: '$t(messageEditor.rePrefix)',
      fwCiteInfo: '$t(messageEditor.reCiteInfo)',
      fwPrefix: 'Fw:',

      to: 'To'
    },
    notifications: {
      newMessage: 'New Message: {{-subject}} From: {{-senderName}}'
    },
    textColour: {
      ariaName: 'Text colour'
    },
    imageUploader: {
      addButton: 'Add image to message',
      placeholder: 'Select image to add',
      name: '{{name}}',
      sizeInfo: '({{width}}x{{height}} pixels) - {{size, size}}',
      scale: 'Scale',
      quality: 'Quality',
      urlPlaceholder: 'Image URL...',
      urlSizeInfo: '{{width}}x{{height}} pixels'
    },
    attachmentEditor: {
      placeholder: 'Click here to add attachment',
      size: '{{size, size}}'
    },
    recipientEditor: {
      placeholder: 'Recipient...'
    },
    rules: {
      title: 'Inbox rules',
      automaticRules: {
        title: 'Automatic rules',
        description: 'Automatic rules are message rules which are processed automatically as messages arrive in ' +
          'the Inbox',
        add: '$t(general:buttons.add)',
        editTitle: 'Edit automatic rule',
        allConditions: '$t(rules.manualRules.allConditions)',
        conditionsTitle: '$t(rules.manualRules.conditionsTitle)',
        addCondition: '$t(rules.manualRules.addCondition)',
        namePlaceholder: '$t(rules.manualRules.namePlaceholder)',
        actionsTitle: '$t(rules.manualRules.actionsTitle)',
        addAction: '$t(rules.manualRules.addAction)',
        save: '$t(rules.manualRules.save)',
        cancel: '$t(rules.manualRules.cancel)',
        noActions: '$t(rules.manualRules.noActions)',
        noConditions: '$t(rules.manualRules.noConditions)',
        noRules: '$t(rules.manualRules.noRules)',
        actions: {
          stop: 'Stop processing after this rule',
          flag: 'Flag message',
          delete: 'Delete',
          quarantine: 'Quarantine',
          markRead: 'Mark read',
          keywords: 'Add keyword',
          keywordPlaceholder: 'Junk',
          copy: 'Copy to folder',
          move: 'Move to folder',
          forward: 'Forward (copy) to',
          forwardfrom: 'Set forward sender addr',
          addressPlaceholder: 'user@example.com',
          header: 'Modify headers',
          headerPlaceholder: 'x-test: data'
        },
        conditionsHeader: {
          field: 'Field',
          insensitive: 'I',
          negate: 'N',
          match: 'Match',
          text: 'Text to match'
        },
        condfields: {
          subject: 'Subject',
          to: 'To',
          cc: 'Cc',
          tocc: 'To or Cc',
          from: 'From',
          fromaddr: 'From address',
          fromtocc: 'From, To or Cc',
          body: 'Body',
          size: 'Size',
          spamscore: 'Spam score',
          quarantine: 'Quarantined',
          markedread: 'Marked read',
          keyword: 'Keyword',
          flag: 'Flagged',
          rulematch: 'Previous rule match',
          datenow: 'Date now',
          timenow: 'Time now',
          msgdate: 'Message Date'
        },
        condmatches: {
          eq: 'equals',
          ne: 'not equals',
          lt: 'less than',
          le: 'less than or equal',
          gt: 'greater than',
          ge: 'greater than or equal',
          ss: 'contains',
          nss: 'not contains',
          wc: 'wildcard',
          nwc: 'not wildcard',
          re: 'regexp',
          nre: 'not regexp'
        }
      },
      manualRuleRunner: {
        close: '$t(general:buttons.close)',
        copyingMessages: 'Copying message to folder {{-folder}}',
        copyingMessages_plural: 'Copying messages to folder {{-folder}}',
        deleting: 'Deleting message',
        deleting_plural: 'Deleting messages',
        doneCopyingMessages: 'Finished copying message',
        doneCopyingMessages_plural: 'Finished copying messages',
        doneDeleting: 'Finished deleting message',
        doneDeleting_plural: 'Finished deleting messages',
        doneMarkingFlagged: 'Finished marking message flagged',
        doneMarkingFlagged_plural: 'Finished marking messages flagged',
        doneMarkingRead: 'Finished marking message read',
        doneMarkingRead_plural: 'Finished marking messages read',
        doneMarkingUnread: 'Finished marking message unread',
        doneMarkingUnread_plural: 'Finished marking messages unread',
        doneMovingMessages: 'Finished moving message',
        doneMovingMessages_plural: 'Finished moving messages',
        error: 'Error - {{error}}',
        findMessages: 'Find matching messages',
        finishedRules: 'Rule processing complete',
        foundMessages: 'Found {{count}} message',
        foundMessages_plural: 'Found {{count}} messages',
        markingFlagged: 'Marking message flagged',
        markingFlagged_plural: 'Marking messages flagged',
        markingRead: 'Marking message read',
        markingRead_plural: 'Marking messages read',
        markingUnread: 'Marking message unread',
        markingUnread_plural: 'Marking messages unread',
        movingMessages: 'Moving message to folder {{-folder}}',
        movingMessages_plural: 'Moving messages to folder {{-folder}}',
        processRule: 'Process Rule {{number}} - {{name}}',
        skipRule: 'Skip Rule {{number}} - {{name}} - must have at least one Condition & Action',
        targetFolderDoesntExist: 'Target folder does not exist',
        title: 'Manual Rule Runner'
      },
      manualRules: {
        title: 'Manual rules',
        description: 'Manual rules are message rules which are triggered manually by the user. These can ' +
          'be used for sorting messages once they have been read from the Inbox. The available actions are more ' +
          'basic than for the automatic rules',
        actionsTitle: 'Actions',
        actions: {
          move: 'Move',
          copy: 'Copy',
          markRead: 'Mark read',
          markUnread: 'Mark unread',
          flag: 'Mark flagged',
          delete: 'Delete'
        },
        add: '$t(general:buttons.add)',
        addAction: 'Add action',
        addCondition: 'Add condition',
        allConditions: 'Need to match all conditions',
        cancel: '$t(general:buttons.cancel)',
        conditionsTitle: 'Conditions',
        condfields: {
          from: 'Sender',
          subject: 'Subject',
          recipient: 'Recipient'
        },
        condmatches: {
          is: 'is',
          notIs: 'is not',
          contains: 'contains',
          notContains: 'does not contain',
          begins: 'begins with',
          ends: 'ends with'
        },
        editTitle: 'Edit manual rule',
        namePlaceholder: 'Rule name',
        noActions: 'No actions defined',
        noConditions: 'No conditions defined',
        noRules: 'No rules defined',
        save: '$t(general:buttons.save)'
      }
    },
    searchBox: {
      placeholder: 'Search...',
      ariaLabel: 'Search messages'
    },
    settings: {
      title: 'Settings',
      autoresponders: {
        title: 'Autoresponders',
        loadError: 'Error loading autoresponder configuration - {{error}}',
        modeAdvanced: 'Advanced',
        modeSimple: 'Simple',
        modeTemplate: 'Template',
        refresh: '$t(general:buttons.reload)',
        templateVariables: {
          title: 'Template variables',
          clear: 'Clear variables'
        },
        advanced: {
          title: 'Advanced autoresponders',
          info: 'This option allows you to create multiple autoresponders with different conditions triggering each. ' +
            'It is intended for advanced users.',
          definitions: 'Autoresponder definitions',
          definitionName: 'Autoresponder name',
          definitionText: 'Response text',
          definitionAdd: '$t(general:buttons.add)',
          definitionEdit: '$t(general:buttons.edit)',
          definitionDelete: '$t(general:buttons.remove)',
          autoresponderNamePersonal: '{{name}}',
          autoresponderNameGlobal: '{{name}} (Template)',
          autoresponderNone: '<None>',
          autoresponderUnknown: '---',
          autoresponderNewName: 'New - {{- date, DATE_SHORT}} {{-date, TIME_24_SIMPLE}}',
          noAutoresponders: 'No autoresponders defined. Click "$t(settings.autoresponders.advanced.definitionAdd)" ' +
            'to add one',
          rules: 'Autoresponder trigger rules',
          ruleName: 'Rule name',
          ruleState: 'State',
          ruleAutoresponder: 'Triggered autoresponder',
          ruleAdd: '$t(settings.autoresponders.advanced.definitionAdd)',
          ruleEdit: '$t(settings.autoresponders.advanced.definitionEdit)',
          ruleDelete: '$t(settings.autoresponders.advanced.definitionDelete)',
          ruleMoveUp: 'Move Up',
          ruleMoveDown: 'Move Down',
          ruleNewName: 'New - {{- date, DATE_SHORT}} {{-date, TIME_24_SIMPLE}}',
          noRules: 'No trigger rules defined. Click "$t(settings.autoresponders.advanced.ruleAdd)" to add one ' +
            '(at least one autoresponder must be available first).',
          reset: '$t(settings.autoresponders.reset)',
          save: 'Save autoresponders',
          saveSuccess: '$t(settings.autoresponders.saveSuccess)',
          saveAutoresponderError: 'An error occurred saving at least one autoresponder definition. Please ' +
            'press the "$t(settings.autoresponders.refresh)" button to resynchronise with the server. ' +
            'The autoresponder trigger rules have not been saved',
          ruleStates: {
            active: 'Active',
            activeSender: 'Depends on sender',
            activeSubject: 'Depends on subject',
            activeSenderSubject: 'Depends on sender & subject',
            activeTime: 'Active now',
            activeTimeSender: 'Active now, depending on sender',
            activeTimeSubject: 'Active now, depending on subject',
            activeTimeSenderSubject: 'Active now, depending on sender & subject',
            inactive: 'Inactive because of date/time',
            inactiveSender: '$t(settings.autoresponders.advanced.ruleStates.inactive)',
            inactiveSubject: '$t(settings.autoresponders.advanced.ruleStates.inactive)',
            inactiveSenderSubject: '$t(settings.autoresponders.advanced.ruleStates.inactive)',
            disabled: 'Disabled',
            locked: ' (locked by admin)'
          },
          autoresponderEditor: {
            title: '{{-name}}',
            name: 'Autoresponder name',
            namePlaceholder: '$t(settings.autoresponders.advanced.autoresponderEditor.name)',
            text: 'Response message',
            textPlaceholder: '$t(settings.autoresponders.advanced.autoresponderEditor.text)',
            keep: 'Keep original message',
            keepWarning: 'If this is not checked, then the incoming message will be discarded after the ' +
              'autoresponder is processed',
            checkLog: 'Only respond to the same sender once within every',
            checkLogSuffix: 'hours',
            checkLogPlaceholder: '',
            respondAfter: 'Only respond after this many messages from the sender',
            respondAfterPlaceholder: '',
            sender: 'Autoresponder "From" address',
            senderPlaceholder: 'Email address',
            replyto: 'Autoresponder "Reply-to" address"',
            replytoPlaceholder: '$t(settings.autoresponders.advanced.autoresponderEditor.senderPlaceholder)',
            subject: 'Autoresponder "Subject"',
            subjectPlaceholder: 'Subject',
            subjectPrefixPlaceholder: 'Subject prefix',
            subjectModeSubject: 'Subject',
            subjectModePrefix: 'Prefix',
            subjectModeDefaultPrefix: 'Default prefix',
            to: 'Send the automatic response to these addresses',
            toPlaceholder: '$t(settings.autoresponders.advanced.autoresponderEditor.senderPlaceholder)',
            copyto: 'Send the original message to these addresses',
            copytoPlaceholder: '$t(settings.autoresponders.advanced.autoresponderEditor.senderPlaceholder)',
            sendToOriginalSender: 'Send the automatic response to the original sender'
          },
          autoresponderRuleEditor: {
            title: 'Rule: {{-name}}',
            name: 'Name',
            namePlaceholder: '$t(settings.autoresponders.advanced.autoresponderRuleEditor.name)',
            autoresponder: 'Autoresponder to trigger',
            autoresponderNone: '$t(settings.autoresponders.advanced.autoresponderNone)',
            autoresponderNameGlobal: '$t(settings.autoresponders.advanced.autoresponderNameGlobal)',
            autoresponderNamePersonal: '$t(settings.autoresponders.advanced.autoresponderNamePersonal)',
            ruleEnable: 'Enable this rule',
            triggerConditions: 'Trigger conditions',
            triggerConditionInfo: 'Specify the conditions below to make this autoresponder trigger. All conditions ' +
              'which are specified must match for the autoresponder to be triggered, so leave conditions blank if ' +
              'you do not want that data tested. Leaving all entries blank will make the autoresponder always ' +
              'trigger.',
            dates: 'Trigger between these dates (regardless of time)',
            times: 'Trigger between these times (regardless of date)',
            dateTimes: 'Trigger between these dates & times',
            daysOfWeek: 'Trigger on these days of the week',
            subject: 'Trigger if the subject matches this',
            subjectPlaceholder: 'Subject (wildcards or regexp)',
            subjectDescription: 'Wildcards can be used, or surround regular expression with //',
            sender: 'Trigger if the original sender matches this',
            senderPlaceholder: 'Sender (wildcards or regexp)',
            senderDescription: '$t(settings.autoresponders.advanced.autoresponderRuleEditor.subjectDescription)',
            buttonOK: '$t(general:buttons.ok)',
            buttonCancel: '$t(general:buttons.cancel)'
          }
        },
        preview: {
          button: 'Show preview',
          loadError: 'Error loading preview - {{error}}',
          subject: 'Subject',
          exampleSubject: 'Example Subject',
          exampleSender: 'Example Sender'
        },
        simple: {
          dates: 'Only respond between these dates (optional)',
          dateSeparator: 'to',
          enable: 'Enable autoresponder',
          text: 'Message',
          title: 'Simple autoresponder',
          frequency: 'The autoresponse will only be sent to the same recipient at most once every {{time}} days',
          reset: '$t(settings.autoresponders.reset)',
          save: '$t(settings.autoresponders.save)',
          saveAutoresponderError: '$t(settings.autoresponders.saveAutoresponderError)',
          saveAutoresponderRuleError: '$t(settings.autoresponders.saveAutoresponderRuleError)',
          saveSuccess: '$t(settings.autoresponders.saveSuccess)'
        },
        template: {
          title: 'Template autoresponder',
          clear: 'Remove autoresponder',
          dates: '$t(settings.autoresponders.simple.dates)',
          dateSeparator: '$t(settings.autoresponders.simple.dateSeparator)',
          enable: '$t(settings.autoresponders.simple.enable)',
          frequency: '$t(settings.autoresponders.simple.frequency)',
          save: '$t(settings.autoresponders.save)',
          saveAutoresponderError: '$t(settings.autoresponders.saveAutoresponderError)',
          saveAutoresponderRuleError: '$t(settings.autoresponders.saveAutoresponderRuleError)',
          saveSuccess: '$t(settings.autoresponders.saveSuccess)',
          selectTemplate: 'Select template autoresponder'
        },
        reset: 'Reset',
        save: 'Save autoresponder',
        saveAutoresponderError: 'Error saving autoresponse - {{error}}',
        saveAutoresponderRuleError: 'Error saving autoresponse rule - {{error}}',
        saveSuccess: 'Saved successfully'
      },
      general: {
        title: 'General',
        alwaysshowimages: 'Always show images when viewing messages',
        language: '$t(login.language)',
        save: 'Save settings',
        saveError: 'The settings could not be saved',
        mailboxQuota: 'Mailbox Quota',
        mailboxNoQuotaNoData: 'No mailbox size limit',
        mailboxQuotaNoData: '{{quota}} MB',
        mailboxNoQuotaData: 'Used {{used, size}} - no size limit',
        mailboxQuotaData: 'Used {{used, size}} of {{quota}} MB',
        sendQuota: 'Send Quota',
        sendQuotaNoneNoDataText: '<tr><th colspan="5">No send quota configured</th></tr>',
        sendQuotaNoneData: '{{messages}}, {{size}}',
        sendQuotaNoneDataText: '<tr><th colspan="5">No quota defined</th></tr>' +
          '<tr class="noquota"><td colspan="5">Usage is {{usage}} in the {{-time}}</td></tr>',
        sendTimeLatestHours: 'latest hour',
        sendTimeLatestHours_plural: 'latest {{count}} hours',
        sendTimeLatestDays: 'latest day',
        sendTimeLatestDays_plural: 'latest {{count}} days',
        sendTimeLatestMonths: 'latest month',
        sendTimeLatestMonths_plural: 'latest {{count}} months',
        sendTimeHoursSince: 'hour since {{-start, DATE_SHORT}} {{-start, TIME_24_SIMPLE}}',
        sendTimeHoursSince_plural: '{{count}} hours since {{-start, DATE_SHORT}} {{-start, TIME_24_SIMPLE}}',
        sendTimeDaysSince: 'day since {{-start, DATE_SHORT}}',
        sendTimeDaysSince_plural: '{{count}} days since {{-start, DATE_SHORT}}',
        sendTimeMonthsSince: 'month since {{-start, DATE_SHORT}}',
        sendTimeMonthsSince_plural: '{{count}} months since {{-start, DATE_SHORT}}',
        sendQuotaMessages: '{{count}} message',
        sendQuotaMessages_plural: '{{count}} messages',
        sendQuotaSize: '{{size, size}}',
        sendQuotaText: '<tr><th colspan="5">Sending usage in the {{-time}}:</th></tr>\n{{-usage}}',
        sendQuotaNoDataText: '<tr><th colspan="5">Sending quota for the {{-time}}:</th></tr>{{-usage}}',
        sendQuotaNoDataLimit_3: '<tr><td>{{count}}</td><td>message</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_3_plural: '<tr><td>{{count}}</td><td>messages</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_4: '<tr><td>{{count}}</td><td>remote message</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_4_plural: '<tr><td>{{count}}</td><td>remote messages</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_5: '<tr><td>{{count}}</td><td>recipient</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_5_plural: '<tr><td>{{count}}</td><td>recipients</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_6: '<tr><td>{{count}}</td><td>remote recipient</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_6_plural:
          '<tr><td>{{count}}</td><td>remote recipients</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_7:
          '<tr><td>{{count, sizeB0}}</td><td>total size</td><td></td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_8:
          '<tr><td>{{count, sizeB0}}</td><td>remote size</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_9:
          '<tr><td>{{count, sizeB0}}</td><td>total recipient-size</td><td></td><td></td><td></td></tr>',
        sendQuotaNoDataLimit_10:
          '<tr><td>{{count, sizeB0}}</td><td>remote recipient-size</td><td></td><td></td><td></td></tr>',
        sendQuotaText_3: '<tr class="{{className}}">{{-usage}}{{-limit}}<td></td></tr>',
        sendQuotaUsage_3: '<td>{{count}}</td><td>message</td>',
        sendQuotaUsage_3_plural: '<td>{{count}}</td><td>messages</td>',
        sendQuotaLimit_3: '<td>of</td><td>{{count}}</td>',
        sendQuotaText_4: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_4: '<td>{{count}}</td><td>remote message</td>',
        sendQuotaUsage_4_plural: '<td>{{count}}</td><td>remote messages</td>',
        sendQuotaLimit_4: '$t(settings.general.sendQuotaLimit_3)',
        sendQuotaText_5: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_5: '<td>{{count}}</td><td>recipient</td>',
        sendQuotaUsage_5_plural: '<td>{{count}}</td><td>recipients</td>',
        sendQuotaLimit_5: '$t(settings.general.sendQuotaLimit_3)',
        sendQuotaText_6: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_6: '<td>{{count}}</td><td>remote recipient</td>',
        sendQuotaUsage_6_plural: '<td>{{count}}</td><td>remote recipients</td>',
        sendQuotaLimit_6: '$t(settings.general.sendQuotaLimit_3)',
        sendQuotaText_7: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_7: '<td>{{count, sizeB0}}</td><td>total size</td>',
        sendQuotaLimit_7: '<td>of</td><td>{{count, sizeB0}}</td>',
        sendQuotaText_8: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_8: '<td>{{count, sizeB0}}</td><td>remote size</td>',
        sendQuotaLimit_8: '$t(settings.general.sendQuotaLimit_7)',
        sendQuotaText_9: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_9: '<td>{{count, sizeB0}}</td><td>total recipient-size</td>',
        sendQuotaLimit_9: '$t(settings.general.sendQuotaLimit_7)',
        sendQuotaText_10: '$t(settings.general.sendQuotaText_3)',
        sendQuotaUsage_10: '<td>{{count, sizeB0}}</td><td>remote recipient-size</td>',
        sendQuotaLimit_10: '$t(settings.general.sendQuotaLimit_7)'
      },
      passwords: {
        title: 'Passwords',
        mainPasswordLabelEnterprise: 'POP3/SMTP/IMAP4 password',
        mainPasswordLabelBasic: 'POP3/SMTP password',
        passwordLabel: 'Password',
        webmailPasswordLabel: 'Webmail password',
        tooShort: 'Password must be at least {{minLength}} characters long',
        timeToCrack: 'Estimated time to crack: {{time}}',
        meter_0: 'Worst',
        meter_1: 'Bad',
        meter_2: 'Weak',
        meter_3: 'Good',
        meter_4: 'Best',
        savePasswords: 'Save password',
        setup: '',

        saveError: {
          tooshort: 'The password was too short',
          scriptchecker: 'Password strength checker script rejected this password',
          pluginchecker: 'Password strength checker plugin rejected this password',
          badcharacter: 'The password contained an invalid character'
        },
        twoFactorAuthentication: {
          totpSecret: 'Secret for manual entry: {{secret}}',
          confirmRegenerateTotpKey: 'If you regenerate the key, then any existing 2FA configurations for this ' +
            'account will no longer work and will need reconfiguring. The new key will be saved when ' +
            'you verify it',
          confirmRegenerateTotpKeyOK: '$t(general:buttons.ok)',
          confirmRegenerateTotpKeyCancel: '$t(general:buttons.cancel)',
          setup2FA: 'Set up two factor authentication',
          verify2FALabel: 'Enter code from authentication app',
          verify2FAPlaceholder: 'authentication code',
          verify2FASuccess: 'Two factor authentication code verified',
          verify2FAAndSaveSuccess: 'Two factor authentication code verified and new key saved',
          saveError: 'Error saving two factor authentication settings - {{error}}',
          saveSuccess: 'Two factor authentication settings saved successfully',
          adminMandated2FA: 'Your administrator has required that you use two factor authentication, so you ' +
            'cannot disable it',
          twoFactorAuthenticationEnabled: 'Two factor authentication is enabled',
          twoFactorAuthenticationDisabled: 'Two factor authentication is disabled. To enable it you need to use an ' +
            'authentication app such as Google Authenticator, scan the barcode to the left and then verify that it ' +
            'is correctly generating one-time passwords before you can enable two factor authentication',
          button: {
            regenerateTotpKey: 'Regenerate key',
            verify: 'Verify two factor authentication code',
            verifyAndSave: 'Verify two factor authentication code and save key',
            enable: 'Enable two factor authentication',
            disable: 'Disable two factor authentication'
          }
        }
      },
      routing: {
        title: 'Routing',
        assistantLabel: 'Assistant',
        assistantInfo: 'The Assistant setting lets you send a copy of messages sent to you. If the Assistant ' +
          'sends a message to you themselves, they will not receive a copy of their own messages, so the Assistant ' +
          'setting may be used to allow someone else to check your messages before forwarding the important ' +
          'ones to you.',
        assistantPlaceholder: 'Email address',
        forwardToAssistantLabel: 'Redirect messages to assistant (rather than copying them)',
        forwardToLabel: 'Message redirection',
        forwardToInfo: 'The message will be redirected to the below recipients',
        forwardToPlaceholder: '$t(settings.routing.assistantPlaceholder)',
        useForwardsLabel: 'Use message redirection settings',
        save: '$t(settings.general.save)',
        saveError: '$t(settings.general.saveError)',
        saveErrorWithExtra: '$t(settings.sending.saveError) - {{-extra}}',
        saveErrors: {
          unknown: 'unrecognised field: {{field}}',
          notallowed: 'writing not allowed to {{field}}',
          validfailed: 'server validation failed for {{field}}',
          thisField: '$t(general:validation.thisField)',
          permissions: 'user permissions don\'t allow this address'
        }
      },
      sending: {
        title: 'Sending',
        realNameLabel: 'Real name',
        realNamePlaceholder: '$t(settings.sending.realNameLabel)',
        emailAddressesLabel: 'Email addresses',
        emailAddressesPlaceholder: '$t(settings.sending.emailAddressesLabel)',
        autoBccLabel: 'Automatically BCC sent messages to this address',
        autoBccPlaceholder: 'Email address',
        markdownPreviewTitle: 'Preview',
        signatureLabel: 'Personal signature',
        signaturePlaceholder: '$t(settings.sending.signatureLabel)',
        signatureMode: 'Signature format',
        signatureHTML: 'HTML',
        signatureMarkdown: 'Markdown',
        signatureText: 'Plain text',
        signatureHTMLInfo: '',
        signatureSize: 'Signature size is {{size, size}}',
        signatureSizeWarning: 'Warning: Signature is large - {{size, size}}',
        signatureMarkdownInfo: '',
        signatureTextInfo: 'We recommend you use Markdown instead of plain text',
        save: '$t(settings.general.save)',
        saveError: '$t(settings.general.saveError)',
        saveErrorWithExtra: '$t(settings.sending.saveError) - {{-extra}}',
        saveErrors: {
          unknown: 'unrecognised field: {{field}}',
          notallowed: 'writing not allowed to {{field}}',
          validfailed: 'server validation failed for {{field}}',
          thisField: '$t(general:validation.thisField)'
        }
      }
    },
    sidebar: {
      folder: 'Folders',
      calendar: 'Calendars'
    }
  }
};
